(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["calculator-form"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const calculateBtn = document.getElementById('calculate-btn');

  if (calculateBtn) {
    calculateBtn.addEventListener('click', calculateCommission);
  }

  // Track form changes
  let formChanged = false;
  document.querySelectorAll('#num-players, #num-teams, #uniforms, #apparel, #contract-years')
    .forEach(el => {
      el.addEventListener('input', () => {
        formChanged = true;
      });
    });

  function calculateCommission() {
    // Get input values
    const numPlayers = parseInt(document.getElementById('num-players').value) || 0;
    const numTeams = parseInt(document.getElementById('num-teams').value) || 0;
    const uniformPrice = parseFloat(document.getElementById('uniforms').value) || 0;
    const apparelPrice = parseFloat(document.getElementById('apparel').value) || 0;
    const contractYears = parseInt(document.getElementById('contract-years').value) || 1;

    // Calculate basic costs
    const uniformCost = uniformPrice * numPlayers;
    const apparelCost = apparelPrice * numPlayers;
    const subtotal = uniformCost + apparelCost;

    // Support service costs
    let designSupport = 500;
    let operationalSupport = 1500;
    let fulfillmentSupport = 500;
    let brandingSupport = 1000;
    let fundraiserSupport = numPlayers * 200;
    let coachCareVisible = false;

    // Apply contract year adjustments
    if (contractYears >= 2) {
      designSupport = 0;
      operationalSupport = 0;
      fundraiserSupport = 0;
    }
    if (contractYears >= 3) {
      coachCareVisible = true;
    }

    // Calculate total support costs
    const totalSupportCosts = designSupport + operationalSupport + fulfillmentSupport + brandingSupport + fundraiserSupport;

    // Calculate price adjustments
    let priceAdjustment = 0;
    let adjustmentPercentage = '0%';
    if (contractYears === 1) {
      priceAdjustment = subtotal * 0.02; adjustmentPercentage = '+2%';
    } else if (contractYears === 2) {
      priceAdjustment = subtotal * 0.03; adjustmentPercentage = '+3%';
    } else if (contractYears === 3) {
      priceAdjustment = subtotal * 0.05; adjustmentPercentage = '+5%';
    }

    // Final total
    const finalTotal = subtotal + totalSupportCosts + priceAdjustment;

    // Update display
    updateDisplay({ 
      uniformCost, apparelCost, subtotal, designSupport, operationalSupport, 
      fulfillmentSupport, brandingSupport, fundraiserSupport, coachCareVisible, 
      contractYears, adjustmentPercentage, priceAdjustment, finalTotal 
    });

    // Animate button only if form was changed
    animateButton();

    // Animate results section
    animateResults();
  }

  function animateButton() {
    const button = document.getElementById('calculate-btn');
    if (formChanged) {
      button.classList.remove('bounce'); 
      void button.offsetWidth; // force reflow
      button.classList.add('bounce');
      formChanged = false; // reset after animation
    }
  }

  function animateResults() {
    const results = document.querySelector('.calculator-results');
    results.classList.remove('animate'); 
    void results.offsetWidth; 
    results.classList.add('animate'); 
  }

  function updateDisplay(data) {
    // Update cost breakdown
    document.getElementById('uniform-cost').textContent = `$${data.uniformCost.toFixed(2)}`;
    document.getElementById('apparel-cost').textContent = `$${data.apparelCost.toFixed(2)}`;
    document.getElementById('subtotal').textContent = `$${data.subtotal.toFixed(2)}`;

    // Update support services
    document.getElementById('design-support').textContent = data.designSupport > 0 ? `$${data.designSupport.toFixed(2)}` : '$0.00';
    document.getElementById('operational-support').textContent = data.operationalSupport > 0 ? `$${data.operationalSupport.toFixed(2)}` : '$0.00';
    document.getElementById('fulfillment-support').textContent = `$${data.fulfillmentSupport.toFixed(2)}`;
    document.getElementById('branding-support').textContent = `$${data.brandingSupport.toFixed(2)}`;
    document.getElementById('fundraiser-support').textContent = data.fundraiserSupport > 0 ? `$${data.fundraiserSupport.toFixed(2)}` : '$0.00';

    // Show/hide coach care
    const coachCareItem = document.getElementById('coach-care-item');
    coachCareItem.style.display = data.coachCareVisible ? 'block' : 'none';

    // Price adjustment
    document.getElementById('price-adjustment').textContent = data.adjustmentPercentage;

    // Final total
    document.getElementById('final-total').textContent = `$${data.finalTotal.toFixed(2)}`;

    // Design Support note
    const designNote = document.getElementById('design-note');
    designNote.style.display = data.contractYears >= 2 ? 'block' : 'none';

    // Operational Support note
    const operationalNote = document.getElementById('operational-note');
    operationalNote.style.display = data.contractYears >= 2 ? 'block' : 'none';

    // Fundraiser Support note
    const fundraiserNote = document.getElementById('fundraiser-note');
    fundraiserNote.style.display = data.contractYears >= 2 ? 'block' : 'none';
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
